/* eslint-disable */
import React, { Component } from "react"
import ReactDOM from "react-dom"
import PropTypes from "prop-types"
import slugify from "slugify"
import Input from "../Input"
import ThemeConsumer from "../ThemeConsumer"
import Loading from "../loading/"
import omit from "ramda/src/omit"

class FloatLabelInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: ""
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
  }

  componentWillMount() {
    if (this.props.value && this.props.value.length) {
      this.handleChange({ target: { value: this.props.value } })
    }
  }

  componentWillReceiveProps(nextProps) {
    const condition = () => {
      return nextProps.value !== this.state.value
    }
    if (condition()) {
      this.handleChange({ target: { value: nextProps.value } })
    }
  }

  handleChange = (ev) => {
    if (this.props.loading) {
      return this.setState({
        value: this.state.value
      })
    }

    this.setState({
      value: ev.target.value
    })
  }

  handleKeyPress = (ev) => {
    if (this.props.onKeyPress && typeof this.props.onKeyPress === "function") {
      this.props.onKeyPress(ev.nativeEvent)
    }
  }

  handleErrorClose = () => {
    this.setState(
      {
        value: ""
      },
      () => {
        if (this.props.onChange && typeof this.props.onChange === "function") {
          this.props.onChange(this.state.value)
        }
      }
    )
  }

  render() {
    const uid = slugify(this.props.label, { lower: true })
    const { theme, upperCase } = this.props
    return (
      <div
        className={`
          ${theme.floatLabel}
          ${this.props.invalid ? theme.invalid : ""}
          ${this.props.icon ? theme.hasIcon : ""}
          ${this.props.loading ? theme.hasLoading : ""}
          ${this.props.disabled ? theme.disabled : ""}
          ${this.props.classNames}
        `}
      >
        <Input
          disabled={this.props.disabled}
          key={uid}
          id={this.props.id}
          type={this.props.type}
          onChange={this.handleChange}
          maxLength={this.props.maxLength}
          onKeyPress={this.handleKeyPress}
          // ref={(ref) => { this[uid] = ref }}
          className={`${
            this.state.value && this.state.value.length ? theme.hasValue : ""
          } ${upperCase && "upperCase"}`}
          value={this.state.value}
          // mask={this.props.mask}
          // formatChars={this.props.formatChars}
          {...omit(["iconClick", "invalid", "loading"], this.props)}
        />
        <label htmlFor={this.props.id}>
          <span>{this.props.label}</span>
          {this.props.required && <span className={theme.required}> *</span>}
        </label>
        <span className={theme.error}>
          {this.props.invalid && this.props.error}
        </span>
        {this.props.icon.length ? (
          <span
            className={`
                ${theme.icon}
                ${
                  this.props.iconClick &&
                  typeof this.props.iconClick === "function"
                    ? theme.pointer
                    : ""
                }
              `}
            onClick={() => {
              if (
                this.props.iconClick &&
                typeof this.props.iconClick === "function"
              ) {
                return this.props.iconClick()
              }
              return ReactDOM.findDOMNode(this).querySelector("input").focus()
            }}
            onKeyPress={() => {}}
            role="button"
            tabIndex={-1}
          >
            <img src={this.props.icon} alt="" />
          </span>
        ) : (
          ""
        )}
        {this.props.secondIcon && (
          <span className={`${theme.secondIcon}`}>
            <img src={this.props.secondIcon} alt="" />
          </span>
        )}
        {this.props.loading ? (
          <span className={theme.loading}>
            <Loading model="secondary" size={21} />
          </span>
        ) : (
          ""
        )}
      </div>
    )
  }
}

FloatLabelInput.propTypes = {
  error: (props, propName) => {
    if (
      props.invalid &&
      (!props[propName] || typeof props[propName] !== "string")
    ) {
      return new Error("Please provide an string error!")
    }
    return null
  },
  invalid: PropTypes.bool,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  type: PropTypes.string,
  icon: PropTypes.string,
  iconClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  maxLength: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  classNames: PropTypes.string
}

FloatLabelInput.defaultProps = {
  error: "",
  invalid: false,
  required: false,
  onKeyPress: () => {},
  type: "text",
  icon: "",
  iconClick: null,
  disabled: false,
  loading: false,
  maxLength: "",
  classNames: ""
}

export default ThemeConsumer("UIFloatLabel")(FloatLabelInput)



// WEBPACK FOOTER //
// ./src/shared/components/FloatLabelInput/index.js